import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { searchResultI } from '@/pages/ProfessionPage/OverViewPage'

interface overviewTypeListI {
  total: number //总画数
  nowPage: number //当前页数
  selectedType: number //浏览模式/表单模式
  overviewList: searchResultI[] //上一次搜索结果列表
}

const initialState: overviewTypeListI = {
  total: 0,
  nowPage: 1,
  selectedType: 0,
  overviewList: []
}

export const setOverviewTypeListSlice = createSlice({
  name: 'setOverviewTypeList',
  initialState,
  reducers: {
    setTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload
    },
    setNowPage: (state, action: PayloadAction<number>) => {
      state.nowPage = action.payload
    },
    setSelectedType: (state, action: PayloadAction<number>) => {
      state.selectedType = action.payload
    },
    setOverviewList: (state, action: PayloadAction<searchResultI[]>) => {
      state.overviewList = action.payload
    }
  }
})
export const { setTotal, setOverviewList, setNowPage, setSelectedType } =
  setOverviewTypeListSlice.actions
export default setOverviewTypeListSlice.reducer
